import clsx from "clsx";

import { DateTimeTz, Icon } from "@web-app/components";
import { RouteTimeline } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

type RouteOptimizeClickActivityPropsType = {
  item: RouteTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
};

export default function RouteOptimizeClickActivity({
  item,
  showTimelineBar,
  timezone,
}: RouteOptimizeClickActivityPropsType) {
  return (
    <li key={item.id} className="relative flex gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon name="locationCrossHairs" className="h-4 text-gray-900" />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-xs leading-5 text-gray-500">
        <span className="inline-block font-medium text-gray-900">
          Route optimized
        </span>
        <span className="relative">
          <DateTimeTz
            start={item?.createdAt}
            timezone={timezone}
            createdBy={item?.createdBy?.name}
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
